
import { Component, Vue } from 'vue-property-decorator'
import Price from '@/components/elements/Price.vue'

@Component({
  components: {
    Price,
  },
})
export default class MobileTotal extends Vue {
  get paymentDueByCreditCard() {
    return this.$store.getters['Cart/paymentDueByCreditCard']
  }
}
